import { useState, useEffect } from 'react'
import './App.css'
import Home from './components/Home'
import Impressum from './components/Impressum'
import Preloader from './components/Preloader'
import CookieConsent from './components/CookieConsent'
import { Helmet } from 'react-helmet'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [showImpressum, setShowImpressum] = useState(false)

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1000)
  }, [])

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Patrick Wollner',
    jobTitle: 'Technology Strategist, AI Consultant, Entrepreneur',
    image: '/img/pw.jpg',
    url: 'https://pwollner.com/',
    sameAs: [
      'https://www.linkedin.com/in/pwollner/',
      'https://www.mckinsey.com/',
      'https://www.bambus.io/'
    ],
    worksFor: {
      '@type': 'Organization',
      name: 'McKinsey & Company',
      url: 'https://www.mckinsey.com/'
    },
    alumniOf: {
      '@type': 'CollegeOrUniversity',
      name: 'University of Cambridge',
      url: 'https://www.cam.ac.uk/'
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Vienna',
      addressCountry: 'Austria'
    }
  }

  if (isLoading) return <Preloader />

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="main_wrap">
        <Home isActive={!showImpressum} />
        {showImpressum && (
          <div className="modal_overlay" onClick={() => setShowImpressum(false)}>
            <div className="modal_content impressum_modal" onClick={e => e.stopPropagation()}>
              <Impressum />
              <button className="modal_close" onClick={() => setShowImpressum(false)} aria-label="Close">×</button>
            </div>
          </div>
        )}
        <nav className="bottom_nav">
          <ul>
            <li><a href="#" className="footer-link" onClick={e => { e.preventDefault(); setShowImpressum(true); }}>Impressum</a></li>
            <li><a href="https://www.linkedin.com/in/pwollner/" target="_blank" rel="noopener noreferrer" className="footer-link">LinkedIn</a></li>
          </ul>
        </nav>
        <CookieConsent />
      </div>
    </>
  )
}

export default App
